<template>
    <v-dialog v-model="detailModal" max-width="600px" :fullscreen="$breakpoint.smAndDown">
        <template v-slot:activator="{props}">
            <v-btn variant="text" color="primary" size="small" v-bind="props" @click.stop="detailModal = true">
                {{ $t('flights.view_details') }}
            </v-btn>
        </template>
        <v-card>
            <v-card-title class="d-flex justify-end">
                <v-icon @click="detailModal = false">mdi-close</v-icon>
            </v-card-title>
            <v-card-text>
                <flight-detail :offer="offer" />
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script lang="ts">
    import {Component, Prop, Vue} from 'vue-facing-decorator'
    import FlightDetail from '~/components/flights/search/offers/FlightDetail.vue'

    @Component({
        components: {
            FlightDetail,
        },
    })
    export class DetailModal extends Vue {
        @Prop()
        offer

        detailModal = false
    }

    export default DetailModal
</script>
